import Head from "next/head";
import Link from "next/link";

import config from "config";
import { FlowSpec } from "config/flow-specs";
import getEnabledFlows from "config/flows";

import { useGetUserDetails } from "auth/auth-state";

import Tag from "ui-components/Tag";
import Divider from "ui-components/Divider";

const FlowBox = ({ flow }: { flow: FlowSpec }) => {
  return (
    <div className="m-2 py-4 px-3 shadow bg-gray-200">
      {flow.active ? (
        <>
          {!flow.public && (
            <div className="flex flex-wrap">
              <Tag
                className="-mt-6"
                bgColorClass="bg-primary-main"
                textColorClass="text-primary-contrastText"
              >
                Private
              </Tag>
            </div>
          )}
          <Link href={`${flow.link}/create`}>
            <a>
              <p className="h4">{flow.title}</p>
              {typeof flow.description === "string" ? (
                <p>{flow.description}</p>
              ) : (
                <div>{flow.description}</div>
              )}
            </a>
          </Link>
        </>
      ) : (
        <>
          <div className="flex flex-wrap">
            <Tag
              className="-mt-6"
              bgColorClass="bg-warning-main"
              textColorClass="text-gray-900"
            >
              Coming Soon
            </Tag>
          </div>

          <div className="cursor-not-allowed">
            <p className="h4">{flow.title}</p>
            <p>{flow.description}</p>
          </div>
        </>
      )}
    </div>
  );
};

const Page = ({ flows }: { flows: FlowSpec[] }) => {
  const userDetails = useGetUserDetails();

  const flowsToPublish = userDetails
    ? flows.filter(
        (f) =>
          userDetails.is_admin ||
          userDetails.private_flows?.includes(f.link) ||
          f.public !== false
      )
    : flows.filter((f) => f.public !== false);
  return (
    <>
      <Head>
        <title>{config.SITE_NAME} | Start Analysis</title>
      </Head>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center pb-4 mb-8">
          <h1 className="h1">Start a New Analysis</h1>
          <h3 className="h3">Do you have a problem in mind?</h3>
          <div className="mx-auto mt-4 pt-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {flowsToPublish.map((s) => (
                <FlowBox key={s.link} flow={s} />
              ))}
            </div>
          </div>
        </div>

        <Divider>Or</Divider>

        <div className="flex flex-wrap -mx-3 mb-3 pb-3">
          <div className="w-full px-3">
            <Link href="/data-files">
              <a>
                <button className="btn px-0 text-white bg-indigo-600 hover:bg-indigo-700 w-full relative flex items-center">
                  Or just explore your data to see insights
                </button>
              </a>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export async function getStaticProps() {
  const enabledFlows = await getEnabledFlows();
  return { props: { flows: enabledFlows } };
}

// Page

export default Page;
